import type {BrandFont} from "@Components/mystuff-brands/brand-kits.types";
import {useAppSelector} from "@/hooks";

export const useBrandFontsMap = (): Record<string, BrandFont> => {
    return useAppSelector(({brands}) => {
        return brands.fonts as Record<string, BrandFont>;
    });
}